import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { debounceTime } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'app-lazy-loading-select',
  templateUrl: './lazy-loading-select.component.html',
  styleUrls: ['./lazy-loading-select.component.scss'],
})
export class LazyLoadingSelectComponent implements OnInit, AfterViewInit {
  pageTitle = '';
  searchMessage = '';
  placeholderMessage = '';
  originalOptionList = [];
  optionList = [];
  disabledId = [];
  displayField: any;
  valueField = '';
  subContent = false;
  subDisplayField = '';
  multiSelect = false;
  maxSelectCount = 0;
  maxSelectMessage = '';
  needFilterSearch = true;
  needTranslation = false;
  selected: any;
  format = '';
  cancelText = '';
  confirmText = '';
  isStaff = false;
  isOrg = false;
  isSpace = false;
  isSpaceStaff = false;
  instantClose = false;
  spaceId = '';
  orgId = '';
  staffNumber = 50;
  staffSearchQuery = [];
  currentPage = 0;
  preventRepeatRequest: boolean = false;
  staffTotal = 0;
  isNotifier = false;
  lastSearchTime = new Date().getTime();
  needShowColor = false;
  searchMes = new FormControl();
  isLoading = false;
  // 防抖
  timer = null;
  searchData = [];
  isAllOrg = false;
  includeUser = false;
  selectedEmps;
  isFirstReview;
  filterParentOrg = null;
  businessScope;
  @ViewChild("amtInput") amtInput: any;
  hkOrg;
  isContractorOrg;

  constructor(
    public dataService: DataService,
    public appService: AppService,
    public router: Router,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalController: ModalController,
    private changeDetectorRef: ChangeDetectorRef,
    public localStorageService: LocalStorageService,
    private translateService: TranslateService) {
    let params = this.navParams.data;
    this.pageTitle = params.pageTitle ? params.pageTitle : '';
    this.placeholderMessage = params.placeholderMessage ? params.placeholderMessage : '';
    this.originalOptionList = params.optionList ? params.optionList : [];
    this.optionList = params.gmpOptionList ? params.gmpOptionList : []
    if (params.displayField instanceof Array) {
      this.displayField = params.displayField.length > 0 ? params.displayField : [];
    } else {
      this.displayField = params.displayField ? params.displayField : '';
    }
    this.valueField = params.valueField ? params.valueField : '';
    this.multiSelect = params.multiSelect ? params.multiSelect : false;
    this.maxSelectCount = Number(params.maxSelectCount) || 0;
    this.maxSelectMessage = params.maxSelectMessage ? params.maxSelectMessage : '';
    this.disabledId = params.disabledId ? params.disabledId : [];
    if (params.needFilterSearch === false) {
      this.needFilterSearch = false;
    }
	  this.subContent = params.subContent ? params.subContent : false;
	  this.subDisplayField = params.subDisplayField ? params.subDisplayField : '';
    if (this.multiSelect) {
      this.selected = params.selected ? params.selected : [];
    } else {
      this.selected = params.selected ? params.selected : '';
    }
    this.needTranslation = params.needTranslation ? params.needTranslation : false;
    this.format = params.format ? params.format : '';
    this.cancelText = params.cancelText ? params.cancelText : 'common.cancel';
    this.confirmText = params.confirmText ? params.confirmText : 'common.confirm';

    this.isStaff = params.isStaff ? params.isStaff : false;
    this.isNotifier = params.isNotifier ? params.isNotifier : false;
    this.isOrg = params.isOrg ? params.isOrg : false;
    this.hkOrg = params.hkOrg ? params.hkOrg : false;
  	this.isSpace = params.isSpace ? params.isSpace : false;
	  this.orgId = params.orgId ? params.orgId : false;
	  this.includeUser = params.includeUser ? true : false;
    this.isContractorOrg = params.isContractorOrg ? params.isContractorOrg : false;
    // 2024-04-18: SCC-1459，单选点击后自动关闭弹框，默认值改为true
  	// this.instantClose = params.instantClose ? params.instantClose : false;
    this.instantClose = true;

    this.isAllOrg = params.isAllOrg ? params.isAllOrg : false;
    this.staffSearchQuery = params.searchQuery;
    this.searchData = params.searchData;
    this.selectedEmps = params.selectedEmps ? params.selectedEmps : null;
    this.filterParentOrg = params.filterParentOrg ? params.filterParentOrg : null;
    this.needShowColor = params.needShowColor ? params.needShowColor : '';
    this.businessScope = params.businessScope ? params.businessScope : '';

    this.searchMes.valueChanges.subscribe((res) => {
      if (res) {
        this.currentPage = 0;
      }
    })
  }

  ngOnInit() {
    // Ionic modal 的 componentProps 是在构造函数之后通过 Object.assign 直接赋值到实例属性上的，
    // 此时才是 pageTitle 的最终原始值（翻译 key），因此翻译必须放在这里而不是构造函数里。
    this.pageTitle = this.translateService.instant(this.pageTitle);
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.pageTitle;
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setTitle({
        title: this.pageTitle // 钉钉设置导航栏标题
      });
    }
    // this.optionList = this.originalOptionList;
    // this.processDisplayValue(this.optionList);
    this.loadMore();

    const that = this;
    window.onpopstate = function () {
      const a = document.getElementsByTagName('app-lazy-loading-select');
      if (a.length > 0) {
        setTimeout(() => {
          that.modalController.dismiss();
          // history.back();
        }, 100)
      }
    };
  }

  ngAfterViewInit() {
    // this.setFocus();
  }

  setFocus() {
    let that = this;
    setTimeout(() => {
        that.amtInput.setFocus();
    }, 150);
  }

  processSubMessage(message: string) {
	message = message ? message : '';
	const stringArr = message.split('/');
	if (stringArr.length < 2) {
		return message;
	}
	return stringArr[0] + '/.../' + stringArr[stringArr.length - 1];
  }

  markSelectedAndClose(item) {
	if (this.multiSelect) {
      this.selected = this.selected ? this.selected : [];
    } else {
      this.selected = this.selected ? this.selected : '';
    }

    if (this.multiSelect && !this.canToggleSelection(item)) {
      return;
    }

    if (!this.multiSelect) {
      if (this.valueField !== '$self') {
        this.selected = item[this.valueField];
      } else {
        this.selected = item;
      }
    } else {
      if (this.valueField !== '$self') {
        if (this.selected.indexOf(item[this.valueField]) === -1) {
          this.selected.push(item[this.valueField]);
        } else {
          this.selected.splice(this.selected.indexOf(item[this.valueField]), 1);
        }
      } else {
        const index = this.selected.map(element => element.id).indexOf(item.id);
        if (index === -1) {
          this.selected.push(item);
        } else {
          this.selected.splice(index, 1);
        }
      }
    }
    this.confirm();
  }

  markSelected(item) {
    if (this.multiSelect) {
      this.selected = this.selected ? this.selected : [];
    } else {
      this.selected = this.selected ? this.selected : '';
    }

    if (this.multiSelect && !this.canToggleSelection(item)) {
      return;
    }

    if (!this.multiSelect) {
      if (this.valueField !== '$self') {
        this.selected = item[this.valueField];
      } else {
        this.selected = item;
      }
    } else {
      if (this.valueField !== '$self') {
        if (this.selected.indexOf(item[this.valueField]) === -1) {
          this.selected.push(item[this.valueField]);
        } else {
          this.selected.splice(this.selected.indexOf(item[this.valueField]), 1);
        }
      } else {
        let index = this.selected.map(element => element.id).indexOf(item.id);
        if (index === -1) {
          // START:: 2024-03-13 多选：禁止勾选disabledId内的数据
          const selectedData = this.selected[index];
          if (this.disabledId.indexOf(item.id) === -1) {
            this.selected.push(item);
          }
          // END:: 2024-03-13 多选：禁止勾选disabledId内的数据
        } else {
          // START:: 2024-03-01 多选：禁止取消勾选disabledId内的数据
          const selectedData = this.selected[index];
          if (this.disabledId.indexOf(selectedData.id) === -1) {
            this.selected.splice(index, 1);
          }
          // END:: 2024-03-01 多选：禁止取消勾选disabledId内的数据
        }
      }
    }
    if(this.hkOrg && !this.selected){
      this.selected = item
    }
    if (!this.multiSelect && this.instantClose) {
      this.confirm();
    }
  }

  isSelected(item) {
    if (this.selected) {
      if (!this.multiSelect) {
        if (this.valueField !== '$self') {
          return this.selected === item[this.valueField];
        } else {
          return this.selected.id === item.id;
        }
      } else {
        if (this.valueField !== '$self') {
          return this.selected.indexOf(item[this.valueField]) !== -1;
        } else {
          return this.selected.some(element => element.id === item.id);
        }
      }
    }
    return false;
  }

  private canToggleSelection(item: any): boolean {
    if (!this.maxSelectCount || this.isSelected(item)) {
      return true;
    }
    if ((this.selected || []).length < this.maxSelectCount) {
      return true;
    }
    if (this.maxSelectMessage) {
      this.appService.toastTip(this.maxSelectMessage, true);
    }
    return false;
  }

  filterOptionList() {
    if (this.searchMessage) {
      let filteredList = [];
      if (this.displayField instanceof Array) {
        filteredList = this.originalOptionList.filter(item => {
          let filterRawInfo = '';
          this.displayField.forEach(field => {
            filterRawInfo += item[field];
          });
          return filterRawInfo.toLowerCase().indexOf(this.searchMessage.toLowerCase()) !== -1;
        });
      } else {
        if (this.displayField == 'spaceName') {
          filteredList = this.originalOptionList;
        } else {
          filteredList = this.originalOptionList.filter(item => item[this.displayField].toLowerCase().indexOf(this.searchMessage.toLowerCase()) !== -1);
        }
      }
      this.optionList = filteredList;
      // console.log('this.optionList1', this.optionList)
     
      this.optionList.forEach(item => {
        if (item.firstName) {
          if (item.firstName.charCodeAt(0) > 255) {
            item.full_name = item.lastName + item.firstName;
          } else {
            item.full_name = item.firstName + ' ' + item.lastName;
          }
        }
      });
    } else {
      this.optionList = this.originalOptionList;
      // console.log('this.optionList2', this.optionList)
      this.optionList.forEach(item => {
        if (item.firstName) {
          if (item.firstName.charCodeAt(0) > 255) {
            item.full_name = item.lastName + item.firstName;
          } else {
            item.full_name = item.firstName + ' ' + item.lastName;
          }
        }
      });
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    }
    this.processDisplayValue(this.optionList);
  }

  async cancel() {
    await this.modalController.dismiss();
    history.back();
  }

  async confirm() {
    if (this.selected instanceof Array) {
      this.selected.forEach(item => {
        if (item.hasOwnProperty('finalDisplay')) {
          delete item.finalDisplay;
        }
      });
    } else {
      if (this.selected.hasOwnProperty('finalDisplay')) {
        delete this.selected.finalDisplay;
      }
    }

    await this.modalController.dismiss(this.selected);
    history.back();
  }

  processDisplayValue(list: any[]) {
    if (this.displayField instanceof Array) {
      if (this.format) {
        list.forEach(item => {
          item.finalDisplay = this.format;
          this.displayField.forEach((field, index) => {
            item.finalDisplay = item.finalDisplay.replace(('$' + (index + 1)), item[field]);
          });
        });
      }
    } else {
      list.forEach(item => {
        item.finalDisplay = item[this.displayField];
      });
    }
  }

  loadMore(event?: any) {
    if (!event) {
      this.currentPage = 0;
    }
    const that = this;
    clearTimeout(that.timer) // 每次进来的时候都将之前的清除掉，如果还没到一秒的时候就将之前的清除掉，这样就不会触发之前setTimeout绑定的事件， 如果超过一秒，之前的事件就会被触发下次进来的时候同样清除之前的timer
    that.timer = setTimeout(() => {
      // 在这里进行我们的操作  这样就不会频繁的进行我们这里面的操作了

      // 显示loading页面（翻页加载已有底部loading，这里只处理首次加载/搜索）
      if (!event) {
        that.isLoading = true;
      }

      if (event) {
        if (that.isStaff) {
          that.getStaffData(event);
        } else if (that.isNotifier) {
          that.getNotifierfData(event);
        } else if (that.isOrg) {
          that.getOrgData(event);
        } else if (that.isFirstReview) {
          that.getFirstReviewer(event);
        } else if(that.hkOrg){
          that.getHkOrgData(event);
        } else if (that.isContractorOrg) {
          that.getContractorOrgData(event);
        }
      } else {
        if (that.isStaff) {
          that.getStaffData(event, 'search');
        } else if (that.isNotifier) {
          that.getNotifierfData(event, 'search');
        } else if (that.isOrg) {
          that.getOrgData(event, 'search');
        } else if (that.isFirstReview) {
          that.getFirstReviewer(event, 'search');
        } else if(that.hkOrg){
          that.getHkOrgData(event, 'search');
        } else if (that.isContractorOrg) {
          that.getContractorOrgData(event, 'search');
        }
      }
    }, 500);
  }

  async getStaffData(event?, flag?): Promise<any> {
    // const param = {
    //   pagingTool: {
    //     currentPage: this.currentPage + 1,
    //     pageSize: 20
    //   },
    //   queryCriterias: this.staffSearchQuery,
    //   queryOrderBies: [{
    //     columnName: 'code',
    //     orderType: 'DESC'
    //   }]
    // };
    let param;
    
    if (!flag) {
      // if (this.staffSearchQuery.length >) {
      //   searchData
      // }
      const data = this.staffSearchQuery.concat(this.searchData ? this.searchData : []);
      param = {
        pagingTool: {
          currentPage: this.currentPage + 1,
          pageSize: 20
        },
        queryCriterias: data,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };
    } else {
      if (this.searchMessage) {
        this.staffSearchQuery = [{
          condition: "like",
          connection: "and",
          isValueADigital: false,
          key: "code",
          value: this.searchMessage,
        }];
      }else{
        this.staffSearchQuery = [];
      }
      const data = this.staffSearchQuery.concat(this.searchData ? this.searchData : []);

      param = {
        pagingTool: {
          currentPage: 1,
          pageSize: 20
        },
        queryCriterias: data,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };

      param.queryCriterias.forEach(element => {
        if (element && element.key == 'short_name') {
          element.value = this.searchMessage;
        }
      });
    }

    if (this.selectedEmps) {
      param.queryCriterias.push({
        condition: "in",
        connection: "and",
        isValueADigital: false,
        key: "selectedEmps",
        value: this.selectedEmps,
      })
    }

    if (this.includeUser) {
      param['params'] = {
        includeUser: true
      };
    }

    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getStaffList(param).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.isLoading = false;

          if (event) {
            event.target.complete();
          }
          this.currentPage++;

          if (!flag) {
            this.originalOptionList = this.originalOptionList.concat(res.DATA);
            // console.log('this.optionList3', this.optionList)
          } else {
            this.originalOptionList = res.DATA;
            // console.log('this.optionList4', this.optionList)
          }
          this.optionList.forEach(item => {
            if (item.firstName) {
              if (item.firstName.charCodeAt(0) > 255) {
                item.full_name = item.lastName + item.firstName;
              } else {
                item.full_name = item.firstName + ' ' + item.lastName;
              }
            }
          });
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
          this.filterOptionList();
          resolve();
        } else {
          that.isLoading = false;
          that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  async getNotifierfData(event?, flag?): Promise<any> {
    console.log(event);
    // const param = {
    //   pagingTool: {
    //     currentPage: this.currentPage + 1,
    //     pageSize: 20
    //   },
    //   queryCriterias: this.staffSearchQuery,
    //   queryOrderBies: [{
    //     columnName: 'code',
    //     orderType: 'DESC'
    //   }]
    // };

    let param;
    if (!flag) {
      param = {
        pagingTool: {
          currentPage: this.currentPage + 1,
          pageSize: 20
        },
        queryCriterias: this.staffSearchQuery,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };
    } else {
      this.staffSearchQuery = [];
      if (this.searchMessage && this.searchMessage.length > 0) {
        this.staffSearchQuery.push({
          condition: "like",
          connection: "and",
          isValueADigital: false,
          key: "code",
          value: this.searchMessage,
        });
      }
      param = {
        pagingTool: {
          currentPage: 1,
          pageSize: 20
        },
        queryCriterias: this.staffSearchQuery,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };

      param.queryCriterias.forEach(element => {
        if (element.key == 'short_name') {
          element.value = this.searchMessage;
        }
      });
    }
    param.queryCriterias.push({
      'connection': 'and',
      'key': 'status',
      'condition': '=',
      'value': '_SYS_A9_1',
      'isValueADigital': false
    })

    const that = this;
    that.dataService.getEmployeesDivisionalList(param).then(res => {
      if (res && res.STATUS === 0) {
        this.isLoading = false;

        if (event) {
          event.target.complete();
        }
        res.DATA.forEach(v => {
          v.tempOrgName = v.orgs && v.orgs.length ? v.orgs[0]['full_name'] : '';
        });
        this.currentPage++;
        if (!flag) {
          this.originalOptionList = this.originalOptionList.concat(res.DATA);
        } else {
          this.originalOptionList = res.DATA;
        }
        // console.log('this.optionList5', this.optionList)
        this.optionList.forEach(item => {
          if (item.firstName) {
            if (item.firstName.charCodeAt(0) > 255) {
              item.full_name = item.lastName + ' ' + item.firstName;
            } else {
              item.full_name = item.firstName + ' ' + item.lastName;
            }
          }
        });
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
        this.filterOptionList();
      } else {
        this.isLoading = false;
        that.appService.toastTip(res.MSG, false);
      }
    });
  }

   async getHkOrgData(event?, flag?): Promise<any> {
    let param;
      let data;
      if (this.searchData) {
        data = this.staffSearchQuery.concat(this.searchData);
      }

      param = {
        pagingTool: {
          currentPage: this.currentPage + 1,
          pageSize: 20
        },
        queryCriterias: data ? data : [],
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };

      if (this.searchMessage && this.searchMessage.length > 0) {
        param.queryCriterias.push({
          condition: "like",
          connection: "and",
          isValueADigital: false,
          key: "code",
          value: this.searchMessage,
        });
      }
      
      if (this.orgId) {
        param.queryCriterias.push({
          'condition': '=',
          'connection': 'and',
          'key': 'top_org_id',
          'value': this.orgId,
          'isValueADigital': false
        })
      }

    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getHkProjectCostCenterCodeListTable(param).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.isLoading = false;

          if (event) {
            event.target.complete();
          }
          this.currentPage++;
          if (!flag) {
            this.originalOptionList = this.originalOptionList.concat(res.DATA);
          } else {
            this.originalOptionList = res.DATA;
          }
          // console.log('this.optionList6', this.optionList)
          // this.optionList.forEach(item => {
          //   if (item.firstName) {
          //     if (item.firstName.charCodeAt(0) > 255) {
          //       item.full_name = item.lastName + item.firstName;
          //     } else {
          //       item.full_name = item.firstName + ' ' + item.lastName;
          //     }
          //   }
          // });
          // this.changeDetectorRef.markForCheck();
          // this.changeDetectorRef.detectChanges();
          this.optionList = this.originalOptionList;
          this.optionList.forEach(item => {
            if (item.firstName) {
              if (item.firstName.charCodeAt(0) > 255) {
                item.full_name = item.lastName + item.firstName;
              } else {
                item.full_name = item.firstName + ' ' + item.lastName;
              }
            }
          });
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
          this.processDisplayValue(this.optionList);
          // this.filterOptionList();
          resolve();
        } else {
          that.isLoading = false;
          that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  async getContractorOrgData(event?, flag?): Promise<any> {
    let param: any;
    let data;
    if (this.searchData) {
      data = this.staffSearchQuery.concat(this.searchData);
    }

    param = {
      pagingTool: {
        currentPage: this.currentPage + 1,
        pageSize: 20
      },
      queryCriterias: data,
      queryOrderBies: [{
        columnName: 'code',
        orderType: 'asc'
      }]
    };

    if (flag) { // search
      if (this.searchMessage && this.searchMessage.length > 0) {
        param.params = {
          name: this.searchMessage
        }
      }
    }

    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSupplierListLazy(param).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.isLoading = false;

          if (event) {
            event.target.complete();
          }
          this.currentPage++;
          if (!flag) {
            this.originalOptionList = this.originalOptionList.concat(res.DATA);
          } else {
            this.originalOptionList = res.DATA;
          }
          // console.log('this.optionList6', this.optionList)
          this.optionList.forEach(item => {
            if (item.firstName) {
              if (item.firstName.charCodeAt(0) > 255) {
                item.full_name = item.lastName + item.firstName;
              } else {
                item.full_name = item.firstName + ' ' + item.lastName;
              }
            }
          });
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
          this.filterOptionList();
          resolve();
        } else {
          that.isLoading = false;
          that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  async getOrgData(event?, flag?): Promise<any> {
    let param;
    if (!flag) {
      let data;
      if (this.searchData) {
        data = this.staffSearchQuery.concat(this.searchData);
      } else {
        data = this.staffSearchQuery;
      }

      param = {
        pagingTool: {
          currentPage: this.currentPage + 1,
          pageSize: 20
        },
        queryCriterias: data,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };
    } else {
      this.staffSearchQuery = [];
      if (this.searchMessage && this.searchMessage.length > 0) {
        this.staffSearchQuery.push({
          condition: "like",
          connection: "and",
          isValueADigital: false,
          key: "code",
          value: this.searchMessage,
        });
      }

      let data;
      if (this.searchData) {
        data = this.staffSearchQuery.concat(this.searchData);
      } else {
        data = this.staffSearchQuery;
      }

      param = {
        pagingTool: {
          currentPage: 1,
          pageSize: 20
        },
        queryCriterias: data,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };

      param.queryCriterias.forEach(element => {
        if (element && element.key == 'short_name') {
          element.value = this.searchMessage;
        }
      });
    }
    if (this.filterParentOrg) { // 筛选子组织架构
      param['params'] = {
        filterParentOrg: this.filterParentOrg
      }
    }

    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      let apiStr = '';
      if (this.isAllOrg) {
        apiStr = 'getOrgList';
      } else {
        apiStr = 'getOrgListTable';
      }
      that.dataService[apiStr](param, this.businessScope).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.isLoading = false;

          if (event) {
            event.target.complete();
          }
          this.currentPage++;
          if (!flag) {
            this.originalOptionList = this.originalOptionList.concat(res.DATA);
          } else {
            this.originalOptionList = res.DATA;
          }
          // console.log('this.optionList6', this.optionList)
          this.optionList.forEach(item => {
            if (item.firstName) {
              if (item.firstName.charCodeAt(0) > 255) {
                item.full_name = item.lastName + item.firstName;
              } else {
                item.full_name = item.firstName + ' ' + item.lastName;
              }
            }
          });
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
          this.filterOptionList();
          resolve();
        } else {
          that.isLoading = false;
          that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  async getFirstReviewer(event?, flag?): Promise<any> {
    let param;
    if (!flag) {
      const data = this.staffSearchQuery.concat(this.searchData);
      param = {
        pagingTool: {
          currentPage: this.currentPage + 1,
          pageSize: 20
        },
        queryCriterias: data,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };
    } else {
      this.staffSearchQuery = [];
      if (this.searchMessage && this.searchMessage.length > 0) {
        this.staffSearchQuery.push({
          condition: "like",
          connection: "and",
          isValueADigital: false,
          key: "code",
          value: this.searchMessage,
        });
      }
      const data = this.staffSearchQuery.concat(this.searchData);

      param = {
        pagingTool: {
          currentPage: 1,
          pageSize: 20
        },
        queryCriterias: data,
        queryOrderBies: [{
          columnName: 'code',
          orderType: 'asc'
        }]
      };

      param.queryCriterias.forEach(element => {
        if (element && element.key == 'short_name') {
          element.value = this.searchMessage;
        }
      });
    }

    if (this.selectedEmps) {
      param.queryCriterias.push({
        condition: "in",
        connection: "and",
        isValueADigital: false,
        key: "selectedEmps",
        value: this.selectedEmps,
      })
    }
    param.queryCriterias.push({
      'connection': 'and',
      'key': 'emp.status',
      'condition': '=',
      'value': '_SYS_A9_1',
      'isValueADigital': false
    })
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getFirstReviewer(param).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.isLoading = false;

          if (event) {
            event.target.complete();
          }
          this.currentPage++;

          if (!flag) {
            this.originalOptionList = this.originalOptionList.concat(res.DATA);
          } else {
            this.originalOptionList = res.DATA;
          }
          this.optionList.forEach(item => {
            if (item.firstName) {
              if (item.firstName.charCodeAt(0) > 255) {
                item.full_name = item.lastName + item.firstName;
              } else {
                item.full_name = item.firstName + ' ' + item.lastName;
              }
            }
          });
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
          this.filterOptionList();
          resolve();
        } else {
          that.isLoading = false;
          that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }
}
